import localStorage from "local-storage";

const CURRENT_PRACTIVCE_KEY = "currentPractice";

const setCurrentPractice = practice => {
  localStorage(CURRENT_PRACTIVCE_KEY, practice);
};

const getCurrentPractice = () => {
  return localStorage(CURRENT_PRACTIVCE_KEY);
};

export { setCurrentPractice, getCurrentPractice };
